import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';
import { Content, Header, Title as AccordionTitle, Text } from '@spa/shared/components/Accordion/styles';
import Accordion from '@spa/shared/components/Accordion';
import { Wrapper as PriceLine, Text as PriceLineText } from '@spa/shared/components/PriceLine/styles';
import Separator from '@spa/shared/components/Unisystem/Separator';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.gap(4, 'column')};
  color: ${props => props.theme.paymentSummary.text};

  ${Separator} {
    border-top: 1px solid ${props => props.theme.colors.paleGray};
  }
`;

export const Info = styled.p`
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.paymentSummary.info};
`;

export const RemainingPayments = styled(Accordion)`
  background: transparent;
  padding: 0;
  overflow-x: hidden;

  ${mediaMin.mediumBreakpoint`
    min-height: min-content;
  `}

  ${Header} {
    ${Text} {
      margin-right: ${props => props.theme.space(2)};
      font-weight: 700;
      font-size: ${props => props.theme.rem(16)};
      line-height: ${props => props.theme.rem(24)};
      color: ${props => props.theme.paymentSummary.accordion.text};
    }

    svg {
      path {
        stroke: ${props => props.theme.paymentSummary.accordion.chevron};
      }
    }

    .resume {
      &.hide {
        animation: slide-out 0.75s both;
      }

      @keyframes slide-out {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(200px);
        }
      }

      &.show {
        animation: slide-in 0.75s both;
      }

      @keyframes slide-in {
        0% {
          transform: translateX(200px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
  }

  ${Content} {
    width: 100%;
    padding: 0;
    overflow-y: auto;

    &.open {
      padding-top: ${props => props.theme.space(2)};
    }
  }
`;

export const TitleWrapperDesktop = styled.div`
  display: flex;
  ${({ theme }) => theme.gap(1)}
  align-items: center;
  flex-grow: 1;
`;

export const TitleWrapperMobile = styled(TitleWrapperDesktop)`
  flex-direction: column;
  ${({ theme }) => theme.gap(0.5, 'column')}
  align-items: flex-start;
`;

export const Title = styled(AccordionTitle)`
  color: ${props => props.theme.paymentSummary.accordion.title};
  font-weight: 600;
  font-size: ${props => props.theme.rem(18)};
  line-height: ${props => props.theme.rem(24)};

  ${mediaMin.mediumBreakpoint`
    font-size: ${props => props.theme.rem(16)};
  `}
`;

export const SubTitle = styled.h4`
  font-family: IntervalNextReg, sans-serif;
  font-weight: 400;
  color: ${props => props.theme.paymentSummary.accordion.title};
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(24)};

  ${mediaMin.mediumBreakpoint`
    font-size: ${props => props.theme.rem(14)};
  `}
`;

export const PaymentsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.gap(2, 'column')};
  color: ${props => props.theme.paymentSummary.accordion.text};
  font-weight: 400;
  font-size: ${props => props.theme.rem(14)};
  line-height: ${props => props.theme.rem(24)};
  padding: 0 ${props => props.theme.space(1)};

  ${Separator} {
    border-top: 1px solid ${props => props.theme.colors.wildSand};
  }
`;

export const PaymentsListCategory = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.gap(1, 'column')};

  ${PriceLine} {
    &.fixed-monthly-bill {
      padding-left: 8px;
    }
  }

  ${PriceLineText} {
    font-weight: 400;
    font-size: ${props => props.theme.rem(14)};
    line-height: ${props => props.theme.rem(24)};

    .included,
    .discount {
      font-weight: 600;
    }
  }
`;

export const CategoryName = styled.h5`
  font-weight: 500;
  font-size: ${props => props.theme.rem(16)};
  line-height: ${props => props.theme.rem(24)};
`;

export const PaymentsListTotal = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.gap(1, 'column')};

  ${PriceLineText} {
    font-weight: 600;
    font-size: ${props => props.theme.rem(16)};
    line-height: ${props => props.theme.rem(24)};

    &:not(:first-child) {
      font-weight: 800;
    }
  }
`;
